import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ps-panel ps-panel--versions" }
const _hoisted_2 = { class: "ver-top-row" }
const _hoisted_3 = { class: "ver-current-badge" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_6 = {
  key: 1,
  class: "spin",
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2"
}
const _hoisted_7 = { class: "ver-timeline" }
const _hoisted_8 = { class: "ver-entry-hd" }
const _hoisted_9 = { class: "ver-tag" }
const _hoisted_10 = { class: "ver-date" }
const _hoisted_11 = { class: "ver-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "ps-panel-hd" }, [
      _createElementVNode("h2", null, "Versões"),
      _createElementVNode("p", null, "Histórico de atualizações do sistema.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 16 16",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.5"
        }, [
          _createElementVNode("polygon", { points: "8 1 10.18 5.41 15 6.18 11.5 9.59 12.36 14.41 8 12.11 3.64 14.41 4.5 9.59 1 6.18 5.82 5.41 8 1" })
        ], -1)),
        _cache[2] || (_cache[2] = _createTextVNode(" Versão atual: ", -1)),
        _createElementVNode("strong", null, "v" + _toDisplayString(_ctx.CURRENT_VERSION), 1)
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["ver-force-btn", { 'ver-force-btn--loading': _ctx.loading }]),
        type: "button",
        disabled: _ctx.loading,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleForceUpdate && _ctx.handleForceUpdate(...args)))
      }, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("polyline", { points: "23 4 23 10 17 10" }, null, -1),
              _createElementVNode("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("path", {
                d: "M12 2a10 10 0 0 1 0 20",
                "stroke-linecap": "round"
              }, null, -1)
            ]))])),
        _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Atualizando…' : 'Forçar atualização'), 1)
      ], 10, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CHANGELOG, (entry) => {
        return (_openBlock(), _createElementBlock("div", {
          key: entry.version,
          class: "ver-entry"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, "v" + _toDisplayString(entry.version), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(entry.date), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.sections, (section) => {
            return (_openBlock(), _createElementBlock("div", {
              key: section.title,
              class: "ver-section"
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(["ver-section-title", `ver-section-title--${section.title.toLowerCase()}`])
              }, _toDisplayString(section.title), 3),
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                  return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                }), 128))
              ])
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}